import React, { useState, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { useInput, useValidator } from '@ers/hooks/';
import { sendEvent } from '@ers/root/App.actions';
import { eventTypes } from '@ers/data/';
import Maybe from 'react-maybe';
import { Button, Input, Spinner } from '@ers/ui';
import { StateManagerProps } from '../Offer';
import useOfferLinkService from '../offer.service';
import { fetchJobOfferLinkCompleted } from '../offer.actions';

const initialHelper = 'np. https://www.pracuj.pl/praca/ksiegowa-warszawa,oferta,123456';
// const urlRegex = /(https?:\/\/)?(www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_+,.~#?&//=]*)/g;

const OfferAddForm = ({ prevState, nextState, applicationId }) => {
    const dispatch = useDispatch();

    const { value, onChange, type, id } = useInput('', 'text');
    const [helper, setHelper] = useState(initialHelper);
    const [valid, setValid] = useState(true);
    const response = useRef(null);
    const setResponse = (r) => {
        response.current = r;
    };

    const success = () => {
        dispatch(sendEvent(eventTypes.addJobOfferLink, {}));
        dispatch(fetchJobOfferLinkCompleted(applicationId, response.current));
        nextState();
    };
    const error = (message) => {
        setHelper(message);
        setValid(false);
    };

    const { trySave, isLoading } = useOfferLinkService();

    const validator = useValidator(value);
    function validateExistance(v) {
        return v && v.length > 0;
    }
    // function isValidHttpUrl(v) {
    //     let url;

    //     try {
    //         url = new URL(v);
    //     } catch (_) {
    //         return false;
    //     }

    //     return url.protocol === 'http:' || url.protocol === 'https:';
    // }
    // function validateUrlFormat(v) {
    //     return isValidHttpUrl(v);
    //     // return urlRegex.test(v);
    // }
    async function validateUrlResponse(v) {
        return trySave({ applicationId, url: v }, setResponse);
    }
    validator
        .addValidation(validateExistance, 'To pole nie może być puste')
        .addValidation(validateUrlResponse, 'Taka strona nie istnieje lub wystąpił na niej błąd')
        .addErrorCallback(error)
        .addSuccessCallback(success);
    const confirmClick = () => {
        validator.run();
    };
    return (
        <div className="offerlink offerlink--column">
            <Maybe
                of={isLoading}
                either={<Spinner />}
                orElse={(
                    <>
                        <Input
                            id={id}
                            value={value}
                            onChange={onChange}
                            type={type}
                            valid={valid}
                            label="Wklej link do ogłoszenia o pracę"
                            helper={helper}
                            autoFocus
                        />
                        <div
                            className="with-margin--top-3"
                            style={{
                                display: 'flex',
                                justifyContent: 'flex-end'
                            }}
                        >
                            <Button.Tertiary onClick={prevState}>
                                Anuluj
                            </Button.Tertiary>
                            <Button.Primary onClick={confirmClick}>
                                Dodaj
                            </Button.Primary>
                        </div>
                    </>
                )}
            />
        </div>
    );
};

OfferAddForm.propTypes = StateManagerProps;

export default OfferAddForm;
